import React from 'react';
import Head from '../layout/head.jsx'
import Content from '../layout/content.jsx'
import Form from '../layout/form.jsx'
import Loader from '../layout/loader.jsx'
import { toast } from 'react-toastify'
import API from '../../services/api.jsx'
import Helpers from "../../services/helpers.jsx";
import DB from '../../services/db.jsx';

class CollectionEdit extends React.Component {
	constructor(props) {
		super(props)

		const fields = {
			name: { label: 'Name', type: 'text', required: true },
		};

      fields.affiliates = {
        label: 'Assigned affiliate(s)',
        type: 'select-multi',
        optionKey: 'affiliates',
        fullWidth: true,
        required: false,
        options: [],
        hidden: (Helpers.isSuperAdmin() || Helpers.checkPermissions('collections:edit') ? false : true) || DB.get('user').affiliates.length === 1,
      };

		this.state = {
			loading: true,
			breadcrumb: {title: 'Back to collection', path: '/assets/collections/' + props.match.params.collectionId},
			fields,
			entity: null
		}
		this.saveEntity = this.saveEntity.bind(this)
	}

	componentDidMount() {
		this.loadCollection();
		// this.loadAffiliateOptions();
	}

	loadCollection() {
		API.getCollection(this.props.match.params.collectionId).then(client => this.setState({ loading: false, entity: client }))
	}

	// loadAffiliateOptions() {
	// 	API.getAffiliates().then((entities) => {
	// 		const affiliates = entities?.data?.map((affiliate) => ({
	// 			key: affiliate.id,
	// 			label: affiliate.name,
	// 		}));
	// 		this.setState((prevState) => ({
	// 			fields: {
	// 				...prevState.fields,
	// 				affiliates: { ...prevState.fields.affiliates, options: affiliates },
	// 			},
	// 		}));
	// 	});
  // }

	saveEntity(fields) {
		if (!Helpers.checkPermissions("collections:edit")) {
      toast.error("You do not have permission to save it");
      return;
    }

		this.setState({ loading: true })
		if(fields.playlists)
			fields.playlists = fields.playlists.map(asset => asset.id)
		else
			fields.playlists = []

		API.update('collections', this.props.match.params.collectionId, fields).then(() => {
			toast.success('Collection has been updated')
			this.props.history.push('/assets/collections/' + this.props.match.params.collectionId)
		}).catch(() => {
			// toast.error('An unexpected error has occured, please try again')
			this.setState({ loading: false })
		})
	}

	render() {
		if(this.state.loading)
			return <Loader />
		else
			return <>
				<Head title={'Edit collection'} breadcrumb={this.state.breadcrumb} />
				<Content>
					<Form fields={this.state.fields} cancel={() => this.props.history.push('/assets/collections/' + this.props.match.params.collectionId)} save={this.saveEntity} entity={this.state.entity} />
				</Content>
			</>
	}
}

export default CollectionEdit;
